<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pnvsM0/tc-custom/9781398486379.jpg?1682168952633" alt="This image is the cover for the book Until We Meet Again"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Until We Meet Again
      </h1>
      <p class="bookDescription body article font2">
        <p>This is an African story of a young black caretaker and the white twin boys in his care and the circumstances and courage that took them to hell and back. Unlike many other books covering the South African Angolan Bush War, the novel Until We Meet Again is the story of April and the twin boys Mark and Andy. The novel will take them on an adventure of survival and courage that will test their love and camaraderie for one another during a time when the divide between black and white in South Africa was controlled by dark forces. The novel is about the everyday lives of the two South African families during the 1960s and 70s when the country was under attack from the Pan African Congress’s Poqo army. April would soon find him in a struggle between his own prospects for a better life for himself and his family, but cannot relinquish his responsibilities to care for the two siblings, which left him with difficult decisions to make which would test his courage to its limits. April became a seasoned freedom fighter and one of the most wanted terrorists in South Africa, while the twins innocently landed themselves in an adventure that had turned into a life-threatening situation that they never dreamed of before. The story will take the reader from the tranquil mountains and rivers of the Eastern Cape to the war-torn Angolan desert where one of the most controversial cold war armed conflicts fuelled by the Americans and Russians would play off and end in a stalemate.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephan Swart
      </h2>
      
      <p class="authorDescription body article">Born and bred in the Eastern Cape of South Africa on the foothills of the Stormberg mountains, Stephan spent most of his childhood exploring the rivers and mountains surrounding the hometown of Burghersdorp. Stephan had qualified as a paratrooper with the South African Defence force before his eighteen birthday and returned home a year later as a seasoned mercenary. After qualifying as an electronic engineer, he specialised in military communication systems. Stephan worked across Africa and Asia where he survived many life-threatening situations. It was during the first COVID lockdown that he decided to seriously put pen to paper.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f1d03270